/* tslint:disable:import-spacing */
/*
tslint:disable:typedef-whitespace tslint:disable:import-spacing no-inferrable-types
variable-name align no-trailing-whitespace component-class-suffix
no-string-literal component-selector
*/

import {ICommand}              from '@/util/i.command';
import {DiversionChange}       from './diversion.change';
import {DiversionSummaryTable} from './diversion.summary.table';

/**
 *
 * @class SummaryTableUnSelectCommand
 *
 * @brief reversible selection changes for the summary table.  This one is for tracking
 * the clear of the selection.
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      July 2020
 *
 */
export class SummaryTableUnSelectCommand implements ICommand {

  private oldValue: DiversionChange;
  private newValue: DiversionChange;
  private table:    DiversionSummaryTable;

  constructor(oldValue: DiversionChange, newValue: DiversionChange, table: DiversionSummaryTable) {

    this.oldValue = oldValue;
    this.newValue = newValue;
    this.table    = table;
  }

  /** effect the command */
  execute() {

    this.table.doSelection(this.newValue);
  }

  /** reverse the command's effects */
  unExecute() {

    this.table.doSelection(this.oldValue);
  }

  /** return a string summary of this command */
  asString(): string {

    const a = (this.oldValue instanceof DiversionChange) ? this.oldValue.id : '';
    const b = (this.newValue instanceof DiversionChange) ? this.newValue.id : '';

    return '[summarytable:unselect] ' + a + ' => ' + b;
  }

}
